import * as yup from 'yup'

export const chatwootSchema = yup.object().shape({
  agenteChatwootSelected: yup.string().required('Agente é obrigatório'),
  inboxChatwootSelected: yup.string().required('Conexão é obrigatória'),
  destinatario: yup.string().required('Destinatário é obrigatório'),
  message: yup
    .string()
    .required('Mensagem é obrigatória')
    .max(300, 'Mensagem deve ter no máximo 300 caracteres'),
  modeloSelecionado: yup.string()
})
